<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-bg">
      <div class="b-container">
        <div class="b-big-title">联合研究中心</div>
        <div class="b-main-bg">
          <div style="position: absolute; left:175px; top:165px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px">
          </div>
          <div style="position: absolute;left: 85px;top: 12px; font-size: 16px; ">赫尔辛基大学</div>
          <div style="position: absolute;left: 85px;top: 33px; font-size: 16px; color: rgb(12, 92, 200);">运动慢病干预</div>
          <div style="position: absolute;left: 82px;top: 57px;width: 100px;height: 1px;border-top: 2px solid rgb(12, 92, 200);"></div>
          <div style="position: absolute;left: 181px;top: 58px;border-top: 108px solid rgb(12, 92, 200);width: 2px;height: 1px;"></div>


          <div style="position: absolute; left:473px; top:299px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px; ">
          </div>
          <div style="position: absolute;left: 423px;top: 33px; font-size: 16px; "><a href="">上海交大转化医学院</a></div>
          <div style="position: absolute;left: 423px;top: 58px;width: 145px;height: 1px;border-top: 2px solid orange;"></div>
          <div style="position: absolute;left: 477px;top: 58px;border-top: 242px solid orange;width: 2px;height: 1px;"></div>

          <div style="position: absolute; left:452px; top:322px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px; ">
          </div>
          <div style="position: absolute;left: 572px;top: 305px; font-size: 16px; "><a href="http://www.translational-medicine.hku.hk/index.html/default.html">香港大学</a></div>
          <div style="position: absolute;left: 572px;top: 325px; font-size: 16px;color:  rgb(12, 92, 200);">创新药物</div>
          <div style="position: absolute;left: 464px;top: 326px;width: 102px;height: 1px;border-top: 2px solid rgb(12, 92, 200);;"></div>

          <div style="position: absolute; left:413px; top:389px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px; ">
          </div>
          <div style="position: absolute;left: 304px;top: 458px; font-size: 16px; ">新加坡国立大学</div>
          <div style="position: absolute;left: 324px;top: 478px; font-size: 16px;color:  rgb(12, 92, 200);">代谢性疾病</div>
          <div style="position: absolute;left: 299px;top: 456px;width: 120px;height: 1px;border-top: 2px solid rgb(12, 92, 200);;"></div>
          <div style="position: absolute;left: 417px;top: 399px;border-top: 58px solid rgb(12, 92, 200);width: 2px;height: 1px;"></div>

          <div style="position: absolute; left:563px; top:504px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px; ">
          </div>
          <div style="position: absolute;left: 694px;top: 486px; font-size: 16px; ">悉尼大学</div>
          <div style="position: absolute;left: 692px;top: 508px; font-size: 16px;color:  rgb(12, 92, 200);">生物医学影像</div>
          <div style="position: absolute;left: 572px;top: 508px;width: 120px;height: 1px;border-top: 2px solid rgb(12, 92, 200);;"></div>

          <div style="position: absolute; left:970px; top:295px"> <img src="../../assets/img/dw.png" style="width: 12px; height: 12px; ">
          </div>
          <div style="position: absolute;left: 1072px;top: 280px; font-size: 16px; "><a href="/yale">耶鲁大学</a></div>
          <div style="position: absolute;left: 1072px;top: 300px; font-size: 16px;color:  rgb(12, 92, 200); width:180px">生物医学统计与数据科学</div>
          <div style="position: absolute;left: 982px;top: 300px;width: 90px;height: 1px;border-top: 2px solid rgb(12, 92, 200);;"></div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      joinList: []
    };
  },
  mounted () {
    this.joinList = [
    ]
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }


.b-center-bg {
  background-size: cover;
  height: 700px;
  padding: 0px;
  .b-big-title {
    color: #000;
    font-size: 22px;
    text-align: center;
    font-weight: normal;
    font-family: microsoft yahei;
    display: block;
    margin-top: 45px;
    margin-bottom: 15px;
  }
  .b-main-bg {
    background: url(../../assets/img/world.png) no-repeat;
    position: relative;
    background-size: cover;
    height: 635px;
  }
}
.b-home-cion {
  width: 35px;
  height: 35px;
  background: url(../../assets/img/dw2.png) no-repeat;
  background-size: cover;
  //-webkit-animation: bounce 0.6s ease-in-out infinite;
  //animation: bounce 0.6s ease-in-out infinite;
  position: absolute;
  right: -40px;
  bottom: -20px;
}
// 图标弹跳动画
@keyframes bounce {
  0% {
    bottom: 0;
  }
  65% {
    bottom: 16px;
  }
  100% {
    bottom: 0;
    border-radius: 49% 47% 42% 40%/60% 60% 40% 40%;
  }
}

.b-joinList {
  position: relative;
  ul li {
    width: 320px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
    height: 80px;
    position: absolute;
    .b-item {
      position: relative;
      .b-item-link {
        display: flex;
        // align-items: center;
        height: 80px;
        overflow: hidden;
        .b-left {
          width: 35%;
          position: relative;
          height: 100%;
          img {
            border-radius: 5px 0 0 5px;
          }
          .b-bg {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 80px 30px;
            border-color: #fff transparent;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .b-right {
          width: 60%;
          .b-right-text {
            position: relative;
            height: 70px;
            margin-top: 5px;
            margin-left: 10px;
            .b-item-name {
              text-align: left;
              font-weight: bold;
              font-family: Avenir, Helvetica, Arial, sans-serif;
              line-height: inherit;
              font-size: 15px;
              color: #000;
              padding-bottom: 5px;
            }
            .b-item-des {
              color: rgb(136, 136, 136);
              font-size: 13px;
              font-weight: normal;
              font-family: microsoft yahei;
              line-height: inherit;
              text-align: left;
            }
            .b-cion {
              width: 25px;
              height: 25px;
              background: url(../../assets/img/aj.png) no-repeat;
              background-size: contain;
              position: absolute;
              right: 5px;
              bottom: 5px;
            }
          }
        }
      }
    }
    &:nth-child(5n + 1) {
      top: 120px;
      left: -10px;
    }
    &:nth-child(5n + 2) {
      left: 290px;
      top: 20px;
    }
    &:nth-child(5n + 3) {
      left: 625px;
      top: 180px;
    }
    &:nth-child(5n + 4) {
      left: 600px;
      top: 265px;
    }
    &:nth-child(5n + 5) {
      left: 760px;
      top: 400px;
    }
  }
  //条目位置
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/index.vue